import { render, staticRenderFns } from "./ConsumerLinkedAccountAlert.vue?vue&type=template&id=5d1403ec"
import script from "./ConsumerLinkedAccountAlert.vue?vue&type=script&lang=ts"
export * from "./ConsumerLinkedAccountAlert.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports